/**
 * filter idTokens passed by getSrcProfile api parameter
 * @param {array} tokens
 * @returns {array} filtered tokens
 */

const filterTokens = tokens => {
  const map = {};
  const result = [];
  if (!tokens.length) {
    return result;
  }
  for (const token of tokens) {
    if (typeof token === 'string') {
      // 1. token must have 3 segments header, claim and signature (ie. header.claim.signature)
      // 2. the claim must have an email key with a value
      const splitToken = token.split('.');
      if (splitToken.length === 3) {
        const claim = splitToken[1];
        let decodedClaim;
        let hashedEmail;
        try {
          decodedClaim = JSON.parse(atob(claim));
        } finally {
          hashedEmail = decodedClaim && decodedClaim.email;
        }
        if (map[hashedEmail]) {
          // put idTokens with same emailHash in one group
          map[hashedEmail].push(token);
        } else if (hashedEmail) {
          map[hashedEmail] = [token];
        }
      }
    }
  }
  for (const key in map) {
    result.push({ key, value: map[key] });
  }
  result.sort((a, b) => b.value.length - a.value.length);
  // filter top 3 emailId tokens
  return result.slice(0, 3).map(element => element.value[0]);
};

export default filterTokens;
